import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      <div className="max-w-4xl mx-auto  rounded-lg p-8 mt-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introduction</h2>
            <p className="text-gray-700 mb-4">
              Jobrise s'engage à protéger et respecter votre vie privée.
              Cette politique de confidentialité explique comment nous collectons, utilisons,
              stockons et protégeons vos informations personnelles lorsque vous utilisez notre
              plateforme de recrutement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informations que nous collectons</h2>
            <h3 className="text-xl font-medium text-gray-700 mb-3">2.1 Informations que vous nous fournissez</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Informations de compte (nom, adresse e-mail, mot de passe)</li>
              <li>Informations de profil professionnel</li>
              <li>CV et documents de candidature</li>
              <li>Données de communication avec les candidats</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">2.2 Informations collectées automatiquement</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Données d'utilisation et de navigation</li>
              <li>Informations sur l'appareil et le navigateur</li>
              <li>Adresse IP et données de géolocalisation</li>
              <li>Cookies et technologies similaires</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Utilisation de l'API Gmail</h2>
            <p className="text-gray-700 mb-4">
              Jobrise utilise l'API Gmail de Google pour vous fournir une messagerie intégrée
              complète dans notre plateforme de recrutement. Voici comment nous utilisons cette fonctionnalité :
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.1 Fonctionnalités de messagerie</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li><strong>Envoi d'e-mails :</strong> Nous utilisons votre compte Gmail pour envoyer des e-mails aux candidats en votre nom</li>
              <li><strong>Réception et synchronisation :</strong> Nous synchronisons vos e-mails entrants liés au recrutement pour afficher les conversations dans notre interface</li>
              <li><strong>Messagerie unifiée :</strong> Nous centralisons vos échanges avec les candidats dans un seul endroit</li>
              <li><strong>Suivi des conversations :</strong> Nous organisons automatiquement vos échanges par candidat et poste</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.2 Données traitées</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li><strong>E-mails liés au recrutement :</strong> Nous accédons aux e-mails échangés avec vos candidats pour les organiser dans notre interface</li>
              <li><strong>Métadonnées :</strong> Expéditeur, destinataire, objet, date d'envoi/réception</li>
              <li><strong>Contenu des messages :</strong> Corps des e-mails pour affichage dans notre messagerie</li>
              <li><strong>Pièces jointes :</strong> CV et documents partagés dans le cadre du recrutement</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.3 Sécurité et contrôle</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li><strong>Authentification sécurisée :</strong> Nous utilisons OAuth 2.0 de Google, aucun mot de passe n'est stocké</li>
              <li><strong>Accès limité :</strong> Nous ne traitons que les e-mails liés à vos activités de recrutement</li>
              <li><strong>Stockage temporaire :</strong> Les e-mails sont synchronisés temporairement pour améliorer les performances</li>
              <li><strong>Contrôle total :</strong> Vous pouvez révoquer l'accès à tout moment dans vos paramètres Google</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.4 Finalités du traitement</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Faciliter la gestion de vos conversations de recrutement</li>
              <li>Améliorer l'organisation de vos échanges avec les candidats</li>
              <li>Fournir des statistiques sur vos communications</li>
              <li>Automatiser le suivi des candidatures</li>
            </ul>

            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
              <p className="text-blue-800">
                <strong>Important :</strong> Jobrise traite uniquement les e-mails liés à vos activités de recrutement.
                Nous n'accédons pas à vos e-mails personnels non liés au recrutement et ne partageons jamais
                le contenu de vos messages avec des tiers sans votre consentement explicite.
              </p>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <p className="text-yellow-800">
                <strong>Transparence :</strong> Cette fonctionnalité nécessite l'accès en lecture à votre Gmail
                pour synchroniser vos conversations de recrutement. Vous gardez un contrôle total et pouvez
                désactiver cette intégration à tout moment.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Comment nous utilisons vos informations</h2>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Fournir et améliorer nos services de recrutement</li>
              <li>Faciliter la communication entre recruteurs et candidats</li>
              <li>Personnaliser votre expérience utilisateur</li>
              <li>Assurer la sécurité et prévenir la fraude</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Partage des informations</h2>
            <p className="text-gray-700 mb-4">
              Nous ne vendons jamais vos informations personnelles. Nous pouvons partager vos informations dans les cas suivants :
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Avec votre consentement explicite</li>
              <li>Pour respecter des obligations légales</li>
              <li>Avec des prestataires de services tiers de confiance (sous contrat strict)</li>
              <li>En cas de fusion, acquisition ou vente d'actifs</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Sécurité des données</h2>
            <p className="text-gray-700 mb-4">
              Nous mettons en place des mesures de sécurité techniques et organisationnelles appropriées :
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Chiffrement des données en transit et au repos</li>
              <li>Authentification forte et contrôle d'accès</li>
              <li>Surveillance et audit réguliers</li>
              <li>Formation du personnel sur la sécurité</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Vos droits</h2>
            <p className="text-gray-700 mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li><strong>Accès :</strong> Obtenir une copie de vos données personnelles</li>
              <li><strong>Rectification :</strong> Corriger des données inexactes</li>
              <li><strong>Effacement :</strong> Demander la suppression de vos données</li>
              <li><strong>Portabilité :</strong> Recevoir vos données dans un format structuré</li>
              <li><strong>Opposition :</strong> Vous opposer au traitement de vos données</li>
              <li><strong>Limitation :</strong> Demander la limitation du traitement</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies</h2>
            <p className="text-gray-700 mb-4">
              Notre site utilise des cookies pour améliorer votre expérience. Vous pouvez contrôler
              l'utilisation des cookies via les paramètres de votre navigateur.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Conservation des données</h2>
            <p className="text-gray-700 mb-4">
              Nous conservons vos informations personnelles aussi longtemps que nécessaire pour
              fournir nos services et respecter nos obligations légales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Modifications</h2>
            <p className="text-gray-700 mb-4">
              Nous pouvons mettre à jour cette politique de confidentialité périodiquement.
              Les modifications importantes vous seront notifiées.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Contact</h2>
            <p className="text-gray-700 mb-4">
              Pour toute question concernant cette politique de confidentialité ou vos données personnelles, contactez-nous :
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700">
                <strong>E-mail :</strong> florian@jobrise.tech<br/>
                <strong>Adresse :</strong> Paris<br/>
                <strong>Téléphone :</strong> +33 (0)7 54 81 52 61
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;